import { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { apis, callApi } from "../../../../api";
import { AccountService } from "../../../../hooks/useAccount";
import { StripeService } from "../../../../hooks/useStripe";

export function StripeSuccess() {
	const navigate = useNavigate();

	useEffect(() => {
		const onboardAccount = async () => {
			if (!StripeService.stripeData) {
				return;
			}

			if (StripeService.stripeData.status === "ACTIVE") {
				navigate("/training/dashboard", { replace: true });
				return;
			}

			try {
				const response = await callApi({
					method: "PATCH",
					url: apis.ONBOARD_ACCOUNT,
					body: {},
				});

				if (!response?.account) {
					navigate("/training/dashboard", { replace: true });
					return;
				}

				if (!AccountService.savedAccount) {
					return;
				}

				AccountService.saveAccount({
					...AccountService.savedAccount,
					requiredKYC: false,
				});
				StripeService.updateStripeData(response.account);

				if (response.account.status === "REQUEST") {
					toast.error("Set up Stripe failed, please try again!");
					navigate("/stripe", { replace: true });
					return;
				}

				navigate("/training/dashboard", { replace: true });
			} catch (error) {
				toast.error("Set up Stripe failed, please try again!");
				navigate("/stripe", { replace: true });
			}
		};

		onboardAccount();
	}, [navigate]);

	return <div />;
}
